/**
 * Listening to variant changes and triggering event that eventually toggles variant spesific content visible.
 *
 * @since 2022-09-27
 * @author Approosters
 */

document.addEventListener('DOMContentLoaded', function(event) {
  var forms = document.body.querySelectorAll('form.product-single__form');
  
  for (var i = 0; i < forms.length; i++) {
    var form = forms[i];
    
    form.addEventListener('change', function() {
      variant_changed(this, this.querySelector('[name="id"]').value);
    });
    
    form.addEventListener('approosters:variant-change', function(event) {
      var parent = this.closest('.product-single__meta');  
      var elems = parent.querySelectorAll('.variant-data');

      for (var i = 0; i < elems.length; i++) {
        if (elems[i].getAttribute('data-variant-id') == this.getAttribute('data-current-variant-id')) {
          elems[i].style.display = null;
          elems[i].classList.remove('hide');
        }
        else {
          elems[i].style.display = 'none';
          elems[i].classList.add('hide');
        }
      }

      // 2022-10-12 Disabling add to cart button if presale not possible
      var variables_elm = this.querySelector('[data-approosters-presale][data-presale-variant="' + form.getAttribute('data-current-variant-id') + '"]')
      if (!variables_elm) {
        variables_elm = this.querySelector('[data-approosters-presale][data-presale-product]')
      }
      
      if (variables_elm) {
        if (variables_elm.getAttribute('data-presale-allow')) {
          const button = this.querySelector('button.add-to-cart')
          button.querySelector('[data-add-to-cart-text]').innerHTML = button.querySelector('[data-add-to-cart-text]').getAttribute('data-default-text')
          
          if (variables_elm.getAttribute('data-presale-available') < 1) {
            button.classList.add('disabled')
            button.setAttribute('disabled', 'disabled')
            button.querySelector('[data-add-to-cart-text]').innerHTML = button.querySelector('[data-add-to-cart-text]').getAttribute('data-sold-out-text')
          }
        }
      }
    });

    // 2022-10-12 Prevent overselling items
    form.querySelector('button.add-to-cart').onclick = function(event) {

      /* ajax api testiä 
        fetch(window.Shopify.routes.root + 'products.js?ids=6986241376338')
        .then(function(product) {
          console.log(product)
          event.preventDefault()
        })
      */

      // Search the presale variables
      var variables_elm = form.querySelector('[data-approosters-presale][data-presale-variant="' + form.getAttribute('data-current-variant-id') + '"]')
      if (!variables_elm) {
        variables_elm = form.querySelector('[data-approosters-presale][data-presale-product]')
      }

      if (variables_elm) {
        if (variables_elm.getAttribute('data-presale-allow') && variables_elm.getAttribute('data-presale-available') < 1) {
          event.preventDefault();
          
          console.log('Presale prevented.')
        }
      }
    }
    
    variant_changed(form, form.querySelector('[name="id"]').value);
  }
/*
  // Checking presale items on checkout button click
  console.log(document.querySelector('#CartPageForm'));
  document.querySelector('#CartPageForm').onsubmit = function(event) {
    event.preventDefault();
  }
  document.querySelector('.btn.cart__checkout').onsubmit = function(event) {
    event.preventDefault();
  }
  */

  /*  checkout */
  var checkout_form = document.querySelector('body.checkout form.edit_checkout');
  if (checkout_form) {
    checkout_form.onsubmit = function(event) {
      var nogo = null;
      document.querySelectorAll('body.checkout [data-approosters-presale]').forEach((variables_elm) => {
        if (variables_elm.getAttribute('data-presale-allow')) {
          if (variables_elm.getAttribute('data-presale-available') < 1) {
            nogo = true;
          }
        }
      })

      if (nogo) {
        document.querySelector('body.checkout .presale-modal-warning-overlay').classList.remove('hidden')
      
        event.preventDefault()
      }
    }
  }
});

document.addEventListener('cart:quantity.cart-header', function(event) {
  console.log(event, 'cart:quantity.cart-header')

  const [variant_id, junk] = event.detail[0].split(':')
  
  var variables_elm = document.querySelector('[data-approosters-presale][data-presale-variant="' + variant_id.toString() + '"]')
  if (!variables_elm) {
    variables_elm = document.querySelector('[data-approosters-presale][data-presale-product]')
  }
  
  _init_presale(variables_elm, event.detail[1])
})

document.addEventListener('ajaxProduct:added', function(event) {
  console.log(event, 'ajaxProduct:added')
  
  var variables_elm = document.querySelector('[data-approosters-presale][data-presale-variant="' + event.detail.product.variant_id + '"]')
  if (!variables_elm) {
    variables_elm = document.querySelector('[data-approosters-presale][data-presale-product]')
  }
  
  _init_presale(variables_elm, event.detail.product.quantity)
})

function _init_presale(variables_elm, current_qty) {
  if (variables_elm) {
    if (variables_elm.getAttribute('data-presale-allow')) {
      const form = variables_elm.closest('form')
  
      if ((parseInt(variables_elm.getAttribute('data-presale-qty')) - parseInt(current_qty) + parseInt(variables_elm.getAttribute('data-presale-limit'))) >= 0) {
        variables_elm.setAttribute('data-presale-available', (parseInt(variables_elm.getAttribute('data-presale-qty')) - parseInt(current_qty) + parseInt(variables_elm.getAttribute('data-presale-limit'))))
      }
      else {
        variables_elm.setAttribute('data-presale-available', 0)
      }
      
      const button = form.querySelector('button.add-to-cart')
  
      button.querySelector('[data-add-to-cart-text]').innerHTML = button.querySelector('[data-add-to-cart-text]').getAttribute('data-default-text')
      
      if (variables_elm.getAttribute('data-presale-available') < 1) {
        button.classList.add('disabled')
        button.setAttribute('disabled', 'disabled')
        button.querySelector('[data-add-to-cart-text]').innerHTML = button.querySelector('[data-add-to-cart-text]').getAttribute('data-sold-out-text')
      }
      else {
        button.classList.remove('disabled')
        button.removeAttribute('disabled')
        button.querySelector('[data-add-to-cart-text]').innerHTML = button.querySelector('[data-add-to-cart-text]').getAttribute('data-default-text')
      }
    }
  }
}


function variant_changed(form, current_variant_id) {  
  console.log('[Approosters] Selected Variant: ' + current_variant_id);

  form.setAttribute('data-current-variant-id', current_variant_id);
  form.dispatchEvent(new CustomEvent('approosters:variant-change'));
  form.setAttribute('data-previous-variant-id', current_variant_id);
}




/* Submits the localization form */

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);
